export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const ROLE = 'ROLE';

export const GETTEDDATA = 'GETTEDDATA';